import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private _router: Router) { }

  canActivate() {
    if (sessionStorage.getItem('auth')) {
      return true;
    }
    sessionStorage.clear();
    localStorage.clear()
    this._router.navigate(['/login']);
    return false;
  }
}
